import type { NavigationItem } from "~/types/component";

type StateShape = {
  navigationItems: NavigationItem[];
  currentSelectedItem: number;
  currentSelectedChild: number;
  title: string;
  noBottomNav: boolean;
};

export const usePageStore = defineStore("pageStore", {
  state: (): StateShape => {
    const baseNavigationItems: NavigationItem[] = [
      {
        title: "خانه",
        icon: "svgo-home",
        tagManagerId: "dashboard",
        to: { name: "dashboard" },
      },
      {
        title: "جستجو",
        icon: "svgo-search-adv",
        tagManagerId: "search-advance",
        to: { name: "search-advance" },
      },
      {
        title: "گزارش‌های من",
        icon: "svgo-bag-tick",
        tagManagerId: "reports",
        to: { name: "reports" },
      },
      {
        title: "لیست کمپین‌ها",
        icon: "svgo-campaign-list",
        tagManagerId: "campaigns",
        to: { name: "campaigns" },
      },
      {
        title: "پروفایل ",
        icon: "svgo-profile-circle",
        to: { name: "profile" },
        tagManagerId: "profile",
        isOpen: true,
        children: [
          {
            title: "خرید اشتراک",
            to: { name: "plans" },
          },
          {
            title: "وضعیت اشتراک",
            to: { name: "history-subscription" },
          },
          {
            title: "تاریخچه بلوط",
            to: { name: "history-point" },
          },
          {
            title: "تاریخچه تراکنش",
            to: { name: "history-transaction" },
          },
        ],
      },
    ];

    const currentSelectedItem = 0;
    const currentSelectedChild = 0;

    return {
      navigationItems: baseNavigationItems,
      currentSelectedItem,
      currentSelectedChild,
      title: "",
      noBottomNav: false,
    };
  },
  getters: {
    finalNavigationItems(): NavigationItem[] {
      return this.navigationItems;
    },
    selectedItem(): NavigationItem {
      const currentItem = this.finalNavigationItems[this.currentSelectedItem];
      return currentItem.children
        ? currentItem.children[this.currentSelectedChild]
        : currentItem;
    },
    pageTitle(): string {
      const currentItem = this.selectedItem;
      return this.title ? this.title : currentItem.title;
    },
  },
  actions: {
    setSelectedItem(index: number) {
      this.currentSelectedItem = index;
      this.title = "";
    },
    setSelectedChild(index: number) {
      this.currentSelectedChild = index;
      this.title = "";
    },
    setTitle(title: string) {
      this.title = title;
    },
    setBottomNav(flag: boolean) {
      this.noBottomNav = !flag;
    },
  },
});
